/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as t from "react";
const p = (s, i) => {
  const n = t.useRef(0), m = t.useRef(!1), r = t.useRef(), d = (e) => {
    const l = e.duration;
    let o, u, w = n.current && 1 - n.current;
    e.onStart && e.onStart();
    const a = (f) => {
      o || (o = f), u = f - o + 1;
      const c = u / l + w;
      c <= 1 ? (e.onUpdate && e.onUpdate(c), r.current = window.requestAnimationFrame(a), n.current = c) : (e.onEnd && e.onEnd(1), n.current = 0);
    };
    r.current = window.requestAnimationFrame(a);
  };
  t.useEffect(
    () => (d(s), () => {
      r.current && window.cancelAnimationFrame(r.current);
    }),
    i
  ), t.useEffect(
    () => {
      m.current = !0;
    },
    []
  );
};
export {
  p as useAnimation
};
